import axios from "axios";

const dltBaseUrl = process.env.REACT_APP_DLT_BASE_URL || "http://10.0.20.254:5556/api";

async function checkChainIntegrity(identifier, merchant = false) {
    const safeIdentifier = encodeURIComponent((identifier || "").trim());

    if (!safeIdentifier) {
        throw new Error("PDL number or merchant code is required");
    }
    return await axios.get(`${dltBaseUrl}/monitor/chain-check/${safeIdentifier}?merchant=${merchant}`);
}

async function postTopupPayment(token, payload) {
    const authToken = token || localStorage.getItem("appToken") || localStorage.getItem("adminServicesToken");

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
        },
    };

    return await axios.post(`${dltBaseUrl}/payment/topup`, payload, config);
}

async function postVoidTransaction(token, payload) {
    const authToken = token || localStorage.getItem("appToken") || localStorage.getItem("adminServicesToken");

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
        },
    };

    return await axios.post(`${dltBaseUrl}/payment/void-transaction`, payload, config);
}

async function postMerchantTopup(token, payload) {
    const authToken = token || localStorage.getItem("appToken") || localStorage.getItem("adminServicesToken");

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
        },
    };

    return await axios.post(`${dltBaseUrl}/payment/merchant-topup`, payload, config);
}

async function postCashout(token, payload) {
    const authToken = token || localStorage.getItem("appToken") || localStorage.getItem("adminServicesToken");

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
        },
    };

    return await axios.post(`${dltBaseUrl}/payment/cashout`, payload, config);
}

async function postFundTransfer(token, payload) {
    const authToken = token || localStorage.getItem("appToken") || localStorage.getItem("adminServicesToken");

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
        },
    };

    return await axios.post(`${dltBaseUrl}/payment/fundtransfer`, payload, config);
}

async function postOrderPayment(token, payload) {
    const authToken = token || localStorage.getItem("appToken") || localStorage.getItem("adminServicesToken");

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
        },
    };

    return await axios.post(`${dltBaseUrl}/payment/order-payment`, payload, config);
}

async function getSyncStatus(userId) {
    const safeUserId = encodeURIComponent((userId || "").trim());

    if (!safeUserId) {
        throw new Error("User ID is required");
    }

    return await axios.get(`${dltBaseUrl}/sync/status/${safeUserId}`);
}

async function triggerSync(userId) {
    const safeUserId = encodeURIComponent((userId || "").trim());

    if (!safeUserId) {
        throw new Error("User ID is required");
    }

    return await axios.post(`${dltBaseUrl}/sync/${safeUserId}`);
}

async function postCorrectData(token, payload, isMerchant = false) {
    const authToken = token || localStorage.getItem("appToken") || localStorage.getItem("adminServicesToken");

    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
        },
    };

    const endpoint = isMerchant 
        ? `${dltBaseUrl}/payment/correct-data?merchant=true`
        : `${dltBaseUrl}/payment/correct-data`;

    return await axios.post(endpoint, payload, config);
}

async function applyCreditingAsync(clientId, amount, referenceNo, reason = "Cancelled by Admin", triggeredBy) {
    try {
        if (!clientId || !amount || !referenceNo) {
            console.warn("DLT Crediting: Missing required parameters (clientId, amount, or referenceNo)");
            return;
        }

        const emailAddr = localStorage.getItem("emailAddr");
        const finalTriggeredBy = triggeredBy || emailAddr;
        const finalReferenceNo = referenceNo + "-D";

        if (!dltBaseUrl) {
            console.warn("DLT BaseUrl is not configured.");
            return;
        }

        const payload = {
            userId: String(clientId),
            amount: amount,
            referenceNo: finalReferenceNo,
            reason: reason,
            triggeredBy: finalTriggeredBy,
        };

        try {
            const response = await axios.post(`${dltBaseUrl}/payment/credit`, payload);
            console.info(`DLT Crediting successful: ${response.status}`);
        } catch (axiosError) {
            if (axiosError.response) {
                console.error(`DLT Crediting failed [${axiosError.response.status}]: ${axiosError.response.statusText}`);
            } else {
                console.error(`DLT Crediting error: ${axiosError.message}`);
            }
        }
    } catch (error) {
        console.error(`DLT Crediting error: ${error.message}`);
    }
}

export const dltService = {
    checkChainIntegrity,
    postTopupPayment,
    postVoidTransaction,
    postMerchantTopup,
    postCashout,
    postFundTransfer,
    postOrderPayment,
    getSyncStatus,
    triggerSync,
    postCorrectData,
    applyCreditingAsync,
};
